import { FormControl, MenuItem, Select } from "@mui/material";
import React, { useState, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as EnglishIcon } from "Assets/Icons/Auth/EnglishIcon.svg";
import { ReactComponent as ArabicIcon } from "Assets/Icons/Auth/ArabicIcon.svg";
import { getTranslations } from "Slices/thunks";

import { DirectionContext } from "App";

const LanguageSelection = () => {
  const dispatch = useDispatch();
  const language = localStorage.getItem('LANGUAGE') || "en";
  const [currentLanguage, setCurrentLanguage] = useState(language);

  const { changeDirection } =  useContext(DirectionContext);

  const { Languages } = useSelector((state) => ({
    Languages: state.Common.languages || [],
  }));

  const handleChangeLanguage = (e) => {
    const newLang = e.target.value?.toLowerCase();
    if (currentLanguage === newLang) return;
    changeDirection(newLang);
    // localStorage.setItem("LANGUAGE", newLang);
    // localStorage.setItem("langId", newLang === "en" ? 1 : 2)
    // dispatch(getTranslations());
    // setCurrentLanguage(newLang);
    // document.body.dir = newLang === "en" ? "ltr" : "rtl";
  }

  return (
    <FormControl>
      <Select
        size="small"
        value={language}
        onChange={handleChangeLanguage}
        secondary
        sx={{
          "&>div": {
            display: "flex",
            alignItems: "center",
            gap: "10px",
          },
        }}
      >
        {Languages?.map((item, i) => {
          return (
            <MenuItem
              sx={{
                display: "flex",
                gap: "10px",
                alignItems: "center",
              }}
              value={item.Value?.toLowerCase()}
              key={i}
            >
              {/* {item?.label} <item.icon height={"20px"} width={"20px"} />{" "} */}
              <img src={item.Icon} width={"20px"} />{" "}{item?.Label} 
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default React.memo(LanguageSelection);
